<style scoped>
.calendarlink {
    padding: 20px 10px 5px 10px;
}

.navbar {
    padding: 0 .7em;
    background: rgb(103, 103, 103);
    background: linear-gradient(180deg, rgba(103, 103, 103, 1) 0%, rgba(14, 14, 14, 1) 100%);
    display: flex;
    justify-content: space-between;
    align-items: baseline;
}

.navlink:hover, .calendarlink:hover{
    background-color: #6A6A6A !important;
}

.dropdown .btn {
    border-color: transparent;
}
.dropdown-item > i {
    font-size: unset !important;
}

.dropdown-menu {
    background-color: #3A3A3A;
    border-top-left-radius: 0;
    border-top-right-radius: 0;
    z-index: 9999;
}
.dropdown-item {
    color: #ffffff !important;
    background-color: #3A3A3A !important;
    text-decoration: none !important;
}
.dropdown-version {
    color: #ffffff !important;
    background-color: #3A3A3A !important;
    text-decoration: none !important;
}
.dropdown-item:hover {
    background-color: #6A6A6A !important;
}
hr {
    color: #ffffff !important;
}
.dropdown-position {
    position: absolute;
    right: 0;
    left: auto !important;
}
</style>

<template>
    <div class="navbar bg-general">
        <div class="container-fluid flex-between">
            <div class="flex gap-2">
                <router-link v-if="hasPermission('Home')" :to="{name: 'Home'}" tag="button" class="navlink" 
                    v-tooltip data-bs-placement="bottom" :data-bs-title="$t('navbar.home')" data-bs-toggle="tooltip" data-bs-trigger="hover">
                    <i class="fa-solid fa-home"></i>
                </router-link>
                <router-link v-if="hasPermission('Conversations')" :to="{name: 'Conversations'}" tag="button" class="navlink"
                     v-tooltip data-bs-placement="bottom" :data-bs-title="$t('navbar.conversations')" data-bs-toggle="tooltip" data-bs-trigger="hover">
                    <i class="fa-solid fa-list"></i>
                </router-link>
                <router-link v-if="hasPermission('Connection Test')" :to="{name: 'Connection Test'}" tag="button" class="navlink" 
                    v-tooltip data-bs-toggle="tooltip" data-bs-placement="bottom" :data-bs-title="$t('navbar.connectionTest')" data-bs-trigger="hover">
                    <i class="fa-solid fa-tasks"></i>
                </router-link>
                <router-link v-if="hasPermission('Director Dashboard')" :to="{name: 'Director Dashboard'}" tag="button" class="navlink"
                    v-tooltip data-bs-toggle="tooltip" data-bs-placement="bottom" :data-bs-title="$t('navbar.dirDashboard')" data-bs-trigger="hover">
                    <i class="fa-solid fa-building"></i>
                </router-link>
            </div>
            <div>
                <UpdateCountdown />
            </div>
            <div class="flex gap-2">
                <router-link  v-if="hasPermission('Answerer')" :to="{name: 'Answerer'}" tag="button" class="navlink"
                    v-tooltip data-bs-toggle="tooltip" data-bs-placement="bottom" :data-bs-title="$t('navbar.answerer')" data-bs-trigger="hover"> 
                    <i class="fa-solid fa-headset"></i>
                </router-link>

                <div style="cursor: pointer;" class="calendarlink" v-if="hasPermission('Calendar')">
                    <CalendarPopup/>
                </div>
                
                <div v-tooltip data-bs-toggle="tooltip" data-bs-placement="bottom" data-bs-title="Menu" :data-bs-title="$t('navbar.menu')">
                    <button type="button" data-bs-toggle="dropdown" aria-expanded="false" data-bs-placement="bottom" class="navlink dropdown-toggle">
                       <i class="fa-solid fa-bars"></i>
                    </button>
                    <ul ref="menuDropdown" class="dropdown-menu dropdown-position pt-0">
                        <li class="dropdown-version">
                            <div class="text-white flex-between px-3">
                                <span :class="{'text-green': !IS_PROD}">{{ APP_VERSION }}</span>
                                <template v-for="locale in $i18n.availableLocales">
                                    <div v-if="locale !== $i18n.locale" class="hover:bg-[#6A6A6A] p-1 px-2" @click.prevent="updateLocale(locale)">
                                        <button :key="`locale-${locale}`">{{ locale }}</button>
                                    </div>
                                </template>
                            </div>
                        </li>
                        <hr class="mt-0">
                        <li>
                            <router-link v-if="hasPermission('Connection Historic')":to="{name: 'Connection Historic'}" class="dropdown-item">
                                <i class="fa-solid fa-book-atlas"></i>
                                {{$t('navbar.connectionHistory')}}
                            </router-link>
                        </li>
                        <li>
                            <router-link v-if="hasPermission('Intervention Report Historic')" :to="{name: 'Intervention Report Historic'}" class="dropdown-item">
                                <i class="fa-solid fa-book"></i>
                                {{$t('navbar.irHistory')}}
                            </router-link>
                        </li>
                        <hr v-if="this.$store.permissionStore?.canAccess('canSeeHistoRI') || this.$store.permissionStore?.canAccess('canSeeHistoTest')">
                        <li>
                            <router-link v-if="hasPermission('Agreement')" :to="{name: 'Agreement'}" class="dropdown-item">
                                <i class="fa-solid fa-file-contract"></i>
                                {{$t('navbar.agreement')}}
                            </router-link>
                        </li>
                        <li>
                            <router-link v-if="hasPermission('Schedule')" :to="{name: 'Schedule'}" class="dropdown-item">
                                <i class="fa-solid fa-table"></i>
                                {{$t('navbar.schedule')}}
                            </router-link>
                        </li>
                        <hr v-if="this.$store.permissionStore?.canAccess('canSeeSchedule') || this.$store.permissionStore?.canAccess('canSeeAgreement')">
                        <li>
                            <router-link v-if="hasPermission('Configuration')" :to="{name: 'Configuration'}" class="dropdown-item">
                                <i class="fa-solid fa-gear"></i>
                                {{$t('navbar.configuration')}}
                            </router-link>
                        </li>
                        <li>
                            <router-link :to="{name: 'Password'}" class="dropdown-item">
                                <i class="fa-solid fa-key"></i>
                                {{$t('navbar.passwordReset')}}
                            </router-link>
                        </li>
                        <li>
                            <router-link v-if="hasPermission('Role')" :to="{name: 'Role'}"  class="dropdown-item">
                                <i class="fa-solid fa-user-shield "></i>
                                {{$t('navbar.role')}}
                            </router-link>
                        </li>
                        <hr>
                        <li>
                            <button class="dropdown-item" @click="logout()">
                                <i class="fa-solid fa-power-off"></i>
                                {{ $t('navbar.logout') }}
                            </button>
                        </li>
                    </ul>
                </div>
            </div>
        </div>
    </div>
</template>

<script>
import CalendarPopup from "@/components/calendar/CalendarPopup.vue";
import UpdateCountdown from "@/components/navbar/UpdateCountdown.vue";

    export default {
        name: "Navbar",
        components: {UpdateCountdown, CalendarPopup},
        props: {},
        data() {
            return {
                permissionStore: null,
            }
        },
        computed: {
            APP_VERSION() {
                return `Solu360 (${import.meta.env.VITE_APP_VERSION})`;
            },
            IS_PROD() {
                return import.meta.env.VITE_APP_ENV === "Solu360-Prod";
            },
        },
        methods: {
            logout () {
                this.$store.authUserStore.logout().then(() => {
                    this.$router.push({name: 'Login'});
                });
            },
            hasPermission(routeLink) {
                const route = this.$router.options.routes.find(route => route.name === routeLink);
                const metadata = route && route.meta;
                return !(metadata?.permission_requirement !== undefined && !this.$store.permissionStore?.canAccess(metadata?.permission_requirement));
            },
            async updateLocale(language) {
                await this.changeLocale(language);
                this.$general.updateTooltips();
            },
            async changeLocale(language) {
                this.$i18n.locale = language;
                this.$store.rememberStore.updatePage(this.$.type.name, 'language', language);
            },
        },
        watch: {},
    }
</script>
